module.exports = __webpack_public_path__ + "static/media/زيارة أبرز المعالم الثقافية في جنيف.d5eddeb9.jpeg";